<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span>Resgate de Benefícios</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area segunda-via">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">Resgate de Benefícios</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="wrap-product-detail">
              <div class="advance-info no-margin">
                <div class="tab-control normal">
                  <a href="#description" class="tab-control-item active">
                    <h6>
                      <i class="fa fa-search"></i> Consultar
                    </h6>
                  </a>
                  <a href="#add_infomation" class="tab-control-item">
                    <h6>
                      <i class="fa fa-plus"></i> Nova Solicitação
                    </h6>
                  </a>
                </div>
                <div class="tab-contents">
                  <div class="tab-content-item active" id="description">
                    <RescueFind :dados="resgates"></RescueFind>
                  </div>
                  <div class="tab-content-item" id="add_infomation">
                    <RescueRequest :dados="resgates"></RescueRequest>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import RescueFind from "./partials/crazy-card/CrazyRescueFind.vue";
import RescueRequest from "./partials/crazy-card/CrazyRescueRequest.vue";

export default {
  name: "CrazyRescue",
  props: {
    msg: String
  },
  components: {
    RescueFind,
    RescueRequest
  },

  data() {
    return {
      resgates: []
    };
  },
  filters: {
    capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  methods: {
    formInput: function(required, value) {
      // Define um padrão para estrutura de cada input do formulário
      this.required = required !== undefined ? required : true;
      this.value = value !== undefined ? value : "";

      this.validation = {
        // Status é o inverso do requerido, pois se o input for obrigatório, ele inicia com o status inválido
        // Para que o usuário seja barrado em caso de um submit sem dados
        status: !this.required,
        message: this.required ? "Por favor, preencha o campo acima" : ""
      };
    }
  }
};
</script>
